'use strict';

/**
 * Web Serial: reservar acesso à porta USB no gesto do clique em Upload,
 * antes da compilação remota (que demora e invalida o "user activation").
 */

const SERIAL_HELP =
    'Use Chrome ou Edge, cabo USB de dados, driver da placa (COM no Windows) e confirme o diálogo do navegador.';

export function isWebSerialSupported () {
    return typeof navigator !== 'undefined' &&
        navigator.serial &&
        typeof navigator.serial.getPorts === 'function' &&
        typeof navigator.serial.requestPort === 'function';
}

/**
 * Garante que o site tem pelo menos uma porta serial concedida.
 * Deve ser chamado logo no clique em Upload (antes de compilar na nuvem).
 * @returns {Promise<number>} quantidade de portas concedidas
 */
/**
 * Fecha monitor Ponte e quaisquer portas Web Serial abertas antes de gravar.
 * No Windows a COM demora alguns ms a libertar-se após close().
 */
export async function releaseWebSerialForUpload () {
    const {stopPonteSerialMonitor} = await import('./ponte-serial-monitor');
    await stopPonteSerialMonitor();

    if (!isWebSerialSupported()) return;

    let ports = [];
    try {
        ports = await navigator.serial.getPorts();
    } catch (e) {
        return;
    }

    for (const port of ports) {
        if (!port.readable && !port.writable) continue;
        try {
            await port.close();
        } catch (e) {
            // ignore — pode já estar fechada
        }
    }

    await new Promise(resolve => setTimeout(resolve, 250));
}

export async function ensureWebSerialForUpload () {
    if (!isWebSerialSupported()) {
        throw new Error(
            'Web Serial não está disponível neste navegador. Use Google Chrome ou Microsoft Edge em HTTPS.'
        );
    }
    let ports = await navigator.serial.getPorts();
    if (ports.length >= 1) {
        return ports.length;
    }
    try {
        const port = await navigator.serial.requestPort();
        if (port && typeof port.close === 'function') {
            try {
                if (port.readable || port.writable) {
                    await port.close();
                }
            } catch (e) {
                // porta ainda não aberta — ok
            }
        }
    } catch (err) {
        const name = err && err.name ? String(err.name) : '';
        if (name === 'NotFoundError' || /cancel|abort/i.test(String(err.message || ''))) {
            throw new Error(
                `Porta USB não selecionada. Ao clicar em Upload, escolha a COM do Arduino no diálogo do navegador. ${SERIAL_HELP}`
            );
        }
        throw new Error(
            `Não foi possível aceder à porta USB: ${err && err.message ? err.message : String(err)}. ${SERIAL_HELP}`
        );
    }
    ports = await navigator.serial.getPorts();
    if (ports.length < 1) {
        throw new Error(
            `Nenhuma porta USB ficou disponível após a seleção. ${SERIAL_HELP}`
        );
    }
    return ports.length;
}
